
/**
 * Formats the difference between two dates in a short relative format:
 *  - Less than 1 minute: "Now"
 *  - Less than 1 hour: "X minutes"
 *  - Less than 1 day: "X hours"
 *  - Less than 1 week: "X days"
 *  - Less than 1 month: "X weeks"
 *  - Less than 1 year: "X months"
 *  - More than 1 year: "X years"
 *
 * @param dateOne
 * @param dateTwo
 */
export  function formatShortRelative(
  dateOne: Date,
  dateTwo: Date
): string {
  const diff = Math.abs(dateOne.getTime() - dateTwo.getTime())
  const diffMinutes = Math.round(diff / (1000 * 60))
  const diffHours = Math.round(diff / (1000 * 60 * 60))
  const diffDays = Math.round(diff / (1000 * 60 * 60 * 24))
  const diffWeeks = Math.round(diff / (1000 * 60 * 60 * 24 * 7))
  const diffMonths = Math.round(diff / (1000 * 60 * 60 * 24 * 30))
  const diffYears = Math.round(diff / (1000 * 60 * 60 * 24 * 365))

  if (diffMinutes < 1) {
    return 'Now'
  } else if (diffHours < 1) {
    return `${diffMinutes}m`
  } else if (diffDays < 1) {
    return `${diffHours}h`
  } else if (diffWeeks < 1) {
    return `${diffDays}d`
  } else if (diffMonths < 1) {
    return `${diffWeeks}w`
  } else if (diffYears < 1) {
    return `${diffMonths}mo`
  } else {
    return `${diffYears}y`
  }
}
